define [], () ->
  (ApplicationTemplate, RentappService, $state, $http, RENTAPPLICATION_API_URL, HOST, $uibModal, $cacheFactory) ->
    restrict: "E"
    template: require("./acceptApplication.jade")
    link: (scope, element, attrs) ->
      scope.promptAcceptApplication = (application) ->
        scope.acceptance_email_subject = "Application for #{scope.application.unit_address or 'Address Not Provided'} Approved!"
        scope.acceptance_email_body    = "Congratulations, #{scope.application.applicant_name}! Your application to live at #{scope.application.unit_address} has been approved."
        $uibModal.open
          scope: scope
          controller: require("./acceptApplicationModal/acceptApplicationModal.coffee")
          template: require("./acceptApplicationModal/acceptApplicationModal.jade")
          windowClass: 'accept-modal'
        .result.then () ->
          $cacheFactory.get('$http').removeAll()
          $state.go $state.current.name, $state.params, reload: true



// WEBPACK FOOTER //
// ./directives/acceptRejectApplication/acceptApplication/acceptApplication.coffee